import { Styles, generateClasses } from 'netline-ui';

export const mobileRadioGroupPreferenceClasses = generateClasses('MobileRadioGroupPreference', [
  'root',
  'title',
  'radio',
  'radioGroupWrapper',
] as const);

const styles: Styles = ({ theme: { colors, spacing } }) => ({
  [`&.${mobileRadioGroupPreferenceClasses.root}`]: {
    paddingTop: spacing(1),
  },
  [`.${mobileRadioGroupPreferenceClasses.title}`]: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0.1px',
    color: colors.grey[600],
  },
  [`.${mobileRadioGroupPreferenceClasses.radio}`]: {
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    margin: spacing(1, 0),
    width: '100%',
    ['.MuiFormControlLabel-label']: {
      fontSize: 16,
      lineHeight: '24px',
      letterSpacing: '0.5px',
      color: colors.grey[900],
    },
  },
  [`.${mobileRadioGroupPreferenceClasses.radioGroupWrapper}`]: {
    width: '100%',
  },
});

export default styles;
